OE.addPlugin('Postlist', (function(){

    var Plugin = {},
        Options = {
            'postlistClassName' : 'post-list__list',
            'paginationQuerySelector' : '.navigation.pagination',
            'nextPageQuerySelector' : '.next.page-numbers'
        };

    Plugin.init = function()
    {
        OE.Utils.delegateEvent(
            CLICK,
            docEventListener,
            Options.paginationQuerySelector + ' ' + Options.nextPageQuerySelector
        );
    };

    var docEventListener = function(e)
    {
        loadNextPage(e.target);

        try { e.preventDefault(); } catch(ev) {}
    };

    var getPostListForElement = function(element)
    {
        while (element.parentElement && !element.classList.contains(Options.postlistClassName))
        {
            element = element.parentElement;
        }

        return element;
    };

    var getPaginationForElement = function(element)
    {
        while (element.parentElement && !OE.Utils.matches(element, Options.paginationQuerySelector))
        {
            element = element.parentElement;
        }

        return element;
    };

    var loadNextPage = function(button)
    {
        if(button.classList.contains('is--loading'))
        {
            return;
        }

        var url = button.getAttribute('href');
        var options = {
            onStart : startLoader.bind(button),
            onStop : stopLoader.bind(getPostListForElement(button)),
            onSuccess : replaceButtonWithLoadedList.bind(button)
        };
        OE.Plugins.Ajax.request(url, options);
    };

    var startLoader = function(request)
    {
        var postlist = getPostListForElement(this);
        if(postlist)
        {
            postlist.classList.add('is--loading');
        }
        this.classList.add('is--loading');
    };

    var stopLoader = function(request)
    {
        this.classList.remove('is--loading');
    };

    var replaceButtonWithLoadedList = function(request)
    {
        var postlist = getPostListForElement(this),
            pagination = getPaginationForElement(this),
            html = request.responseText,
            id, parser, xmlDoc, destination_postlist;

        if(postlist)
        {
            id = postlist.getAttribute('id');
            if(id)
            {
                parser = new DOMParser();
                xmlDoc = parser.parseFromString(html, "text/html");
                destination_postlist = xmlDoc.getElementById(id);
                if(destination_postlist)
                {
                    pagination.outerHTML = destination_postlist.innerHTML;
                }
                else
                {
                    postlist.classList.add('has--loading-error');
                }
            }
        }
    };

    return Plugin;
})());
